import * as React from "react"
import "./Banner.scss"

interface BannerProps{
    text:string
    //can add color prop later if needed
}

const Banner = ({text}:BannerProps) => {
    return <div className="banner">{text}</div>
}

export default Banner;
